import { apiRequest } from '../apiRequest';

export const createAdminLoginAsTokenApi = async (adminId) => {
    return apiRequest(`/admin/user/admin-accounts/${adminId}/login-as`, {
        method: 'POST',
        defaultErrorMessage: 'Failed to create login-as token',
    });
};

